// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"daf6c262","71":"daf6c262","96":"daf6c262","392":"daf6c262","509":"daf6c262","583":"daf6c262","622":"daf6c262","649":"daf6c262","696":"89f823d2"}[chunkId] + ".chunk.css";
};